/** Proudly human-made, for people @author Erik Vroon */
import { LightDocumentObjectModelNexusComponent } from "../modules/light-document-object-model-nexus-component";
import { svg, html, css, LitElement } from 'lit';
import { TextToSpeechModule } from "../modules/text-to-speech.module";
import { HighContrastModule } from "../modules/high-contrast.module";
import { StorageModule } from '../modules/storage.module';
import { DocumentLanguageModule } from '../modules/document-language.module';
export class FloatingActionButtonComponent extends LightDocumentObjectModelNexusComponent {


    buttonsState = 'closed';

    accessibilityView = html``;
    accessibilityViewState = 'closed';

    permissionsView = html``;
    permissionsViewState = 'closed';

    feedbackView = html``;
    feedbackViewState = 'closed';

    helpdeskView = html``;
    helpdeskViewState = 'closed';

    accessibilityEnlargeTextState = 'inactive';
    accessibilityTextToSpeechState = 'inactive';
    accessibilityDarkThemeState = 'inactive';
    accessibilityHighContrastState = 'inactive';

    adBlockerHeuristic = 'dunno';


    highContrastModule = new HighContrastModule();

    cookieModuleLoaded = false;
    chatWidgetState = 'loading';

    storageModule = new StorageModule();

    noAds = document.querySelector('.no-ads');

    permissionsButtonState = 'loading';
    permissionsVisibility = 'd-none';

    documentLanguageModule = new DocumentLanguageModule();
    language = this.documentLanguageModule.getLanguageFromDocument();

    noAdsModeEventHappened = false;

    textToSpeechModule;

    tcfLoadedBeforeAdsModeEvent = false;

    // TODO: store accessibility settings in session storage
    // TODO: check for intermittent light/dark theme issue when clicking on FAB trigger
    // When dark theme is selected, and the page reloads, and then the FAB trigger is clicked, the theme resets to light
    // TODO: high contrast mode tweaks + fix for dynamic-light/dynamic-dark
    // TODO: navbar, a simple solution for correct icon color + correct sticky top color

    constructor() {
        super();
        // this.storageModule.setItem('localStorage', 'color-theme', _value);
        // let themeLocalStorage = this.storageModule.getItem('localStorage', 'color-theme');
        this.setEventListeners();
    }

    /**
     * 
     * @returns Boolean
     */
    isCookieButtonLoadable() {
        let returnValue = false;
        if (noAds ||
            typeof window !== 'undefined' &&
            typeof window.googlefc !== 'undefined' &&
            typeof window.googlefc.showRevocationMessage !== 'undefined'
        ) {
            returnValue = true;
        }
        return returnValue;
    }

    firstUpdated() {
        this.setInitialState();
        let textToSpeechLocalStorage = this.storageModule.getItem('localStorage', 'text-to-speech');
        document.addEventListener('text-to-speech-loaded-old', (event) => {
            console.log('text-to-speech-loaded-old', event, textToSpeechLocalStorage, event.data.voices.length);
            if (event.data.voices.length > 0) {
                if (textToSpeechLocalStorage) {
                    switch (textToSpeechLocalStorage) {
                        case '1':
                            this.accessibilityTextToSpeechState = 'inactive';
                            this.handleTextToSpeech();
                            break;
                        case '0':
                            this.accessibilityTextToSpeechState = 'active';
                            this.handleTextToSpeech();
                            break;
                        case null:
                            this.accessibilityTextToSpeechState = 'active';
                            this.handleTextToSpeech();
                            break;
                    }
                }
                this.requestUpdate(); // for showing the button..
            }
        });
        document.addEventListener('text-to-speech-loaded-new', () => {
            console.log('text-to-speech-loaded-new');
            if (textToSpeechLocalStorage) {
                switch (textToSpeechLocalStorage) {
                    case '1':
                        this.accessibilityTextToSpeechState = 'inactive';
                        this.handleTextToSpeech();
                        break;
                    case '0':
                        this.accessibilityTextToSpeechState = 'active';
                        this.handleTextToSpeech();
                        break;
                    case null:
                        this.accessibilityTextToSpeechState = 'active';
                        this.handleTextToSpeech();
                        break;
                }
            }
            this.requestUpdate(); // for showing the button..
        });

        this.textToSpeechModule = new TextToSpeechModule();
        this.textToSpeechModule.initialize();
        // this.themeId = this.getBody().getAttribute('data-bs-theme');
        let themeLocalStorage = this.storageModule.getItem('localStorage', 'color-theme');
        if (themeLocalStorage) {
            switch (themeLocalStorage) {
                case 'dark':
                    this.accessibilityDarkThemeState = 'active';
                    this.requestUpdate();
                    break;
                case 'light':

                    break;
                case 'high-contrast':
                    this.accessibilityDarkThemeState = 'active';
                    this.accessibilityHighContrastState = 'active';
                    this.requestUpdate();
                    break;
            }
        }
        console.log('themeId', this.themeId);

        let enlargeTextLocalStorage = this.storageModule.getItem('localStorage', 'enlarge-text');
        console.log('firstUpdated: enlargeTextLocalStorage', enlargeTextLocalStorage);
        if (enlargeTextLocalStorage) {
            switch (enlargeTextLocalStorage) {
                case '1':
                    this.accessibilityEnlargeTextState = 'inactive';
                    this.handleEnlargeText();
                    break;
                case '0':
                    this.accessibilityEnlargeTextState = 'active';
                    this.handleEnlargeText();
                    break;
            }
        }
    }

    setEventListeners() {

        // currently there are some orderings:
        // - for ads mode with ad/tracking blocker
        // - for ads mode with no ad/tracking blocker
        // - for no-ads mode

        document.addEventListener('cookie-module-loaded', (event) => {
            // console.log('FAB: cookie module loaded...:', data.module);
            if (event && event.data && event.data.module) {
                console.log('FAB: cookie module loaded:', event.data.module);
                this.cookieModuleLoaded = true;
                this.cookieModule = event.data.module;
                // this.permissionsVisibility = 'd-none';
                // this.permissionsButtonState = 'loading';
                this.requestUpdate();
                // alert(`cookie-module-loaded`);
            }
        });

        document.addEventListener('revoke-cookie-choice', (event) => {
            console.log('FAB: revoke-cookie-choice callback handler called', event);
            // alert(`revoke-cookie-choice`);
            // There is another case, where the user first opens the banner, and then selects again.
            // that should also be handled

            // probably combine it with this below tcfLoadedBeforeAdsModeEvent if-statement
            if (this.tcfLoadedBeforeAdsModeEvent == false) {
                this.permissionsVisibility = 'd-none';
                this.permissionsButtonState = 'loading';
            }
            if (this.noAdsModeEventHappened == true) {
                this.permissionsVisibility = 'd-none';
                this.permissionsButtonState = 'loaded';
            }
        });

        document.addEventListener('cookie-module-no-ads-mode', (event) => {
            console.log('FAB: cookie-module-no-ads-mode', event);
            this.permissionsVisibility = 'd-none';
            this.permissionsButtonState = 'loaded';
            this.requestUpdate();
            // alert(`cookie-module-no-ads-mode`);
            this.noAdsModeEventHappened = true;
        });

        document.addEventListener('cookie-module-ads-mode', (event) => {
            console.log('FAB: cookie-module-ads-mode', event);
            // this.permissionsVisibility = 'd-none';
            // this.permissionsButtonState = 'loading';
            if (this.tcfLoadedBeforeAdsModeEvent == true) {
                this.permissionsVisibility = 'd-none';
                this.permissionsButtonState = 'loaded';
                // alert('cookie-module-ads-mode loaded where tcf loaded before ads mode event');
            }
            // alert('cookie-module-ads-mode loaded');
            this.requestUpdate();
        });

        document.addEventListener('tcf-cookie-module-loaded', (event) => {
            console.log('FAB: tcf-cookie-module-loaded', event);
            this.tcfLoadedBeforeAdsModeEvent = true;
            this.permissionsVisibility = 'd-none';
            this.permissionsButtonState = 'loaded';
            // alert(`tcf-cookie-module-loaded`);
            this.requestUpdate();
        });

        document.addEventListener('non-functional-cookies-accepted', (event) => {
            console.log('FAB: non-functional-cookies-accepted', event);
        });

        document.addEventListener('non-functional-cookies-accepted-tcf', (event) => {
            console.log('FAB: non-functional-cookies-accepted-tcf', event);
            // this.permissionsVisibility = 'd-flex';
            // this.permissionsButtonState = 'loaded';
            // this.requestUpdate();
        });

        this.handleChatWidgetLoad();

        window.addEventListener('load', () => {
            this.handleIt();
        });
    }

    /**
     * Freschat hangs out in GTM for now, so we cannot know for sure if after window load fcWidget is there.
     * So we poll some times, and if found, activate the chat widget state to 'loaded', and request a template update.
     * So the chat widget may pop in some time after loading.
     * A better solution would be to integrate freshchat directly, but probably works in most normal cases.
     * Anyways, the chat widget will not be shown if an ad blocker is used, so fcWdget may never exist.
     * Therefore just some attempts.
     */
    handleChatWidgetLoad() {
        let fcWidgetTryAttempts = 5;
        let attempt = 0;
        this.handleIt = () => {
            if (window && window.fcWidget) {
                // window.fcWidget.on('widget:loaded', () => {
                console.log('widget loaded handler...');
                let iframeSelector = '#fc_widget';
                let iframe = document.documentElement.querySelector(iframeSelector);
                console.log('iframe', iframe);
                this.chatWidgetState = 'loaded';
                this.helpDeskButtonVisibility = 'd-none';
                this.requestUpdate();
                // });
            } else {
                console.log('fc widget not found yet, attempt', attempt, 'with max', fcWidgetTryAttempts);
                setTimeout(() => {
                    attempt += 1;
                    if (attempt < fcWidgetTryAttempts) {
                        this.handleIt();
                    }
                }, 500);
            }
        }
    }

    getBody() {
        let body = document.querySelector('body');
        return body;
    }

    render() {
        return html`${this.doRender()}`;
    }

    /**
     * 
     * @returns 
     */
    doRender() {
        let result = html``;
        result = html`

        <div class="">
            <div class="d-flex flex-column-reverse floating-action-buttons-column overflow-visible position-relative">
                ${this.renderFloatingActionTriggerButton('menu', 'shown', 'Actiemenu', 'menu-dots', 'Menu icoon')}
                ${this.renderSegment('accessibility', 'hidden', 'Toegankelijkheid', 'accessibility', 'Toegankelijkheid')}
                ${this.renderSegment('permissions', 'hidden', 'Toestemmingen', 'cookie', 'Toestemmingen')}
                ${this.renderSegment('feedback', 'hidden', 'Feedback/idee delen', 'emoji-emotions', 'Emoji icoon')}
                ${this.renderSegment('helpdesk', 'hidden', 'Helpdesk', 'question-answer', 'Vraag antwoord icoon')}        
            </div>

        </div>
        `;
        return result;
    }

    /**
     * 
     * TODO: DOM translations
     * 
     * @param {*} title 
     * @param {*} iconIdentifier 
     * @param {*} iconTitle 
     * @returns 
     */
    renderSegment(identifier, state, title, iconIdentifier, iconTitle) {
        let template = html``;

        // if (state == 'shown') {
        template = [];


        let _segmentButtonTemplate = html`
            <div class="row">
               <div class="col-auto ms-auto pe-0">
                    <button
                        id=${identifier}
                        title=${title}
                        type="button"
                        class="btn btn-floating-action-button rounded-5 fw-normal mb-3 ms-auto ${state} fab-button overflow-visible"
                        @mouseenter="${this.handleButtonMouseEnter}"
                        @mouseout="${this.handleButtonMouseOut}"
                        @click="${this.handleButtonMouseClick}"
                        >
                            <div class="row">
                                <div class="col text-align-start align-self-center pe-0 title-column d-none">
                                    <small>
                                        ${title}
                                    </small>
                                </div>
                                <div class="col-auto py-1">
                                    <svg class="${iconIdentifier} svg-icon svg-icon-hover svg-icon-size-30 static-color align-self-end my-auto">
                                        <title>${iconTitle}</title>
                                        <use href="#icon-${iconIdentifier}"></use>
                                    </svg>
                                </div>
                            </div>
                    </button>
                </div>
            </div>

            `;

        switch (identifier) {
            case 'accessibility':
                // segmentButtonTemplate = html``;
                template.push(_segmentButtonTemplate);
                break;
            case 'permissions':
                let permissionsVisibility = 'd-none';
                // if (this.accessibilityViewState == 'open') {
                if (this.noAds) {
                    permissionsVisibility = 'd-flex';
                }
                _segmentButtonTemplate = html`
                    <div class="row">
                        <div class="col pe-0">
                            <button
                                id=${identifier}
                                title=${title}
                                type="button"
                                class="btn btn-floating-action-button rounded-5 fw-normal mb-3 ms-auto ${state} ${this.permissionsVisibility} fab-button overflow-visible"
                                @mouseenter="${this.handleButtonMouseEnter}"
                                @mouseout="${this.handleButtonMouseOut}"
                                @click="${this.handleButtonMouseClick}"
                                >
                                    <div class="row">
                                        <div class="col text-align-start align-self-center pe-0 title-column d-none">
                                            <small>
                                                ${title}
                                            </small>
                                        </div>
                                        <div class="col-auto py-1">
                                            <svg class="${iconIdentifier} svg-icon svg-icon-hover svg-icon-size-30 static-color align-self-end my-auto">
                                                <title>${iconTitle}</title>
                                                <use href="#icon-${iconIdentifier}"></use>
                                            </svg>
                                        </div>
                                    </div>
                            </button>
                        </div>
                    </div>
                    `;

                if (this.permissionsButtonState == 'loaded') {
                    // alert('template permissionsButtonState loaded');
                    template.push(_segmentButtonTemplate);
                }
                break;
            case 'feedback':
                let link = this.querySelector('.feedback-link');
                if (link && link.content && link.content.textContent) {
                    // console.log('feedback-link', link.content.textContent, link);
                    _segmentButtonTemplate = html`
                    <div class="row">
                        <div class="col-auto ms-auto pe-0">
                            <a 
                            href="${link.content.textContent}"
                            class="btn btn-floating-action-button rounded-5 fw-normal mb-3 ms-auto ${state} fab-button"
                            target="_blank"
                            @mouseenter="${this.handleButtonMouseEnter}"
                            @mouseout="${this.handleButtonMouseOut}"
                            title="${title}"
                            >
                                <div class="row">
                                    <div class="col text-align-start align-self-center pe-0 title-column d-none">
                                        <small>
                                            ${title}
                                        </small>
                                    </div>
                                    <div class="col-auto py-1">
                                        <svg class="${iconIdentifier} svg-icon svg-icon-hover svg-icon-size-30 static-color align-self-end my-auto">
                                            <title>${iconTitle}</title>
                                            <use href="#icon-${iconIdentifier}"></use>
                                        </svg>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    `;
                    template.push(_segmentButtonTemplate);
                }
                break;
            case 'helpdesk':
                this.helpDeskButtonVisibility = 'd-none';
                if (this.helpdeskViewState == 'open') {
                    this.helpDeskButtonVisibility = 'd-none';
                }
                if (this.helpdeskViewState == 'closed') {
                    this.helpDeskButtonVisibility = 'd-none';
                }
                _segmentButtonTemplate = html`
                    <div class="row">
                        <div class="col-auto ms-auto pe-0">
                            <button
                                id=${identifier}
                                title=${title}
                                type="button"
                                class="btn btn-floating-action-button rounded-5 fw-normal mb-3 ms-auto ${state} ${this.helpDeskButtonVisibility} fab-button overflow-visible"
                                @mouseenter="${this.handleButtonMouseEnter}"
                                @mouseout="${this.handleButtonMouseOut}"
                                @click="${this.handleButtonMouseClick}"
                                >
                                    <div class="row">
                                        <div class="col text-align-start align-self-center pe-0 title-column d-none">
                                            <small>
                                                ${title}
                                            </small>
                                        </div>
                                        <div class="col-auto py-1">
                                            <svg class="${iconIdentifier} svg-icon svg-icon-hover svg-icon-size-30 static-color align-self-end my-auto">
                                                <title>${iconTitle}</title>
                                                <use href="#icon-${iconIdentifier}"></use>
                                            </svg>
                                        </div>
                                    </div>
                            </button>
                        </div>
                    </div>
                    `;
                if (this.chatWidgetState == 'loaded') {
                    template.push(_segmentButtonTemplate);
                }
                break;
        }

        switch (identifier) {
            case 'accessibility':
                let accessibilityVisibility = 'invisible';
                if (this.accessibilityViewState == 'open') {
                    accessibilityVisibility = 'd-flex';
                }
                if (this.accessibilityViewState == 'closed') {
                    accessibilityVisibility = 'd-none';
                }
                // this.textToSpeechModule.hasSpeechSynthesis == true
                template.push(html`
                        <div class="row mb-3 shadow-sm ${accessibilityVisibility}">
                                <div class="col-12">
                                ${this.renderViewHeader(iconTitle, iconIdentifier, title)}
                                <div class="row bg-floating-action-button rounded-0 rounded-bottom-3 pt-3">
                                    <div class="col-6 mb-3">
                                        <button @click="${this.handleEnlargeText}" class="btn ${this.getButtonClassBasedOnState(this.accessibilityEnlargeTextState)} w-100" type="button">
                                            <div class="row rounded-0 rounded-top-3 py-3">
                                                <div class="col-auto mx-auto mb-3">
                                                    <div class="row">
                                                        <div class="col ${this.getButtonIconBackgroundClassBasedOnState(this.accessibilityEnlargeTextState)} rounded-circle p-2">
                                                            <svg lang="en-GB" class="svg-icon svg-icon-hover svg-icon-size-40 static-color align-self-end my-auto ${this.getButtonIconClassBasedOnState(this.accessibilityEnlargeTextState)}">
                                                                <title>Letters icoon</title>
                                                                <use xlink:href="#icon-enlarge-text"></use>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 align-self-center fw-bold">
                                                    Vergroot tekst
                                                </div>
                                            </div>
                                        </button>
                                    </div>
                                    
                                    ${this.renderTextToSpeechButtonTemplate()}
                                    <div class="col-6 mb-3 d-flex align-items-stretch">
                                        <theme-picker
                                            @nexus-theme-switched="${this.handleNexusThemeSwitched}"
                                            flow="floating-action-button"
                                            state="${this.accessibilityDarkThemeState}"
                                            class="border-1 d-flex"
                                            themeid="${this.themeId}"
                                            @user-prefers-dark-color-scheme="${this.handleUserPrefersDarkColorScheme}"
                                            >
                                        </theme-picker>
                                    </div>
                                    <div class="col-6 mb-3">
                                        <button @click="${this.handleHighContrastButtonClick}" type="button" class="btn ${this.getButtonClassBasedOnState(this.accessibilityHighContrastState)} w-100">
                                            <div class="row rounded-0 rounded-top-3 py-3">
                                                <div class="col-auto mx-auto mb-3">
                                                    <div class="row">
                                                        <div class="col ${this.getButtonIconBackgroundClassBasedOnState(this.accessibilityHighContrastState)} rounded-circle p-2">
                                                            <svg lang="en-GB" class="svg-icon svg-icon-hover svg-icon-size-40 static-color align-self-end my-auto ${this.getButtonIconClassBasedOnState(this.accessibilitHighContrastState)}">
                                                                <title>Contrast icoon</title>
                                                                <use xlink:href="#icon-contrast"></use>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 align-self-center fw-bold">
                                                    Hoog contrast
                                                </div>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                `);
                // }
                break;
            case 'permissions':
                if (this.permissionsViewState == 'open') {
                    this.handleRevokeButtonClick();
                    // template.push(html`
                    //         <div class="row mb-3 me-1 ms-3">
                    //             <div class="col-12">
                    //                 ${this.renderViewHeader(iconTitle, iconIdentifier, title)}
                    //                 <div class="row bg-floating-action-button rounded-0 rounded-bottom-3 pt-3">
                    //                     <div class="col-12">
                    //                         <p>Je kunt je toestemming voor niet-functionele cookies aanpassen.()
                    //                             Als je de volgende knop gebruikt dan herlaad de pagina en kun je
                    //                             niet-functionele cookies accepteren of weigeren.
                    //                         </p>
                    //                     </div>
                    //                     <div class="col-12">
                    //                         <button @click="${this.handleRevokeButtonClick}" type="button" class="btn btn-primary revoke-cookie-choice">Toestemming aanpassen</button>
                    //                     </div>
                    //                     <div class="col-12">
                    //                         <svg-animation-component></svg-animation-component>
                    //                     </div>
                    //                 </div>
                    //             </div>
                    //         </div>
                    // `);
                }
                break;
            case 'feedback':
                if (this.feedbackViewState == 'open') {
                    //     template.push(html`
                    //         <div class="row mb-3 me-1 ms-3">
                    //             <div class="col-12">
                    //                 ${this.renderViewHeader(iconTitle, iconIdentifier, title)}
                    //                 <div class="row bg-floating-action-button rounded-0 rounded-bottom-3 pt-3">
                    //                     <div class="col-12">

                    //                     </div>
                    //                 </div>
                    //             </div>
                    //         </div>
                    // `);
                }
                break;
            case 'helpdesk':
                console.log('helpdesk...', this.chatWidgetState, this.helpdeskViewState)
                if (this.chatWidgetState == 'loaded' && this.helpdeskViewState == 'open') {
                    window.fcWidget.open();
                    this.helpdeskViewState = 'closed';
                    this.requestUpdate();
                }
                break;

            default:
                break;
        }
        return template;
        // }
    }

    handleUserPrefersDarkColorScheme() {
        console.log('handleUserPrefersDarkColorScheme user-prefers-dark-color-scheme');
        this.storageModule.setItem('localStorage', 'color-theme', 'dark');
        this.accessibilityDarkThemeState = 'active';
        this.requestUpdate();
    }

    renderTextToSpeechButtonTemplate() {
        let template = html``;
        if (this.textToSpeechModule &&
            this.textToSpeechModule.hasSpeechSynthesis === true) {
            template = html`        
            <div class="col-6 mb-3">
                <button @click="${this.handleTextToSpeech}" class="btn ${this.getButtonClassBasedOnState(this.accessibilityTextToSpeechState)} w-100" type="button">
                    <div class="row rounded-0 rounded-top-3 py-3">
                        <div class="col-auto mx-auto mb-3">
                            <div class="row">
                                <div class="col ${this.getButtonIconBackgroundClassBasedOnState(this.accessibilityTextToSpeechState)} rounded-circle p-2">
                                    <svg lang="en-GB" class="${this.getButtonIconClassBasedOnState(this.accessibilityTextToSpeechState)} svg-icon svg-icon-hover svg-icon-size-40 static-color align-self-end my-auto">
                                        <title>Volume icoon</title>
                                        <use xlink:href="#icon-volume-up"></use>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 align-self-center fw-bold">
                            Lees tekst voor
                        </div>
                    </div>
                </button>
            </div>
        `;
        }
        return template;
    }

    handleRevokeButtonClick() {
        console.log('FAB: handleRevokeButtonClick');
        if (this.cookieModuleLoaded == true) {
            if (this.cookieModule.cookiesWithAttributes) {
                this.cookieModule.cookiesWithAttributes.remove(this.cookieModule.cookiesEnablerConfiguration.cookieName);
            }

            if (this.noAds) {
                if (this.cookieModule.cookiesEnablerConfiguration && this.cookieModule.cookiesEnablerConfiguration.bannerClass.length) {
                    let banner = document.querySelector(`.${this.cookieModule.cookiesEnablerConfiguration.bannerClass}`);
                    if (banner) {
                        banner.classList.remove('invisible');
                        this.cookieModule.showBanner();
                        this.triggerEventOnElement('revoke-cookie-choice', document, { module: this.cookieModule });
                    }
                }
            }
        }
        console.log('FAB: will revoke cookie choice tcf')
        this.triggerEventOnElement('revoke-cookie-choice-tcf', document, { module: this.cookieModule });
    }

    handleNexusThemeSwitched(event) {
        console.log('handleNexusThemeSwitched', event.data.state, event.data.themeId);
        this.storageModule.setItem('localStorage', 'nexus-theme-switched', 1);
        switch (event.data.themeId) {
            case 'light':
                this.themeId = 'dark';
                this.accessibilityDarkThemeState = 'active';
                this.accessibilityHighContrastState = 'inactive';
                break;
            case 'dark':
                this.themeId = 'light';
                this.accessibilityDarkThemeState = 'inactive';
                this.accessibilityHighContrastState = 'inactive';
                break;
            case 'high-contrast':
                this.themeId = 'light';
                this.accessibilityDarkThemeState = 'inactive';
                this.accessibilityHighContrastState = 'inactive';
                break;
        }
        this.requestUpdate();
    }

    getButtonClassBasedOnState(state) {
        let _class = `btn-floating-action-button`;
        switch (state) {
            case 'active':
                _class = `btn-primary`;
                break;
            case 'inactive':
                _class = `btn-floating-action-button`;
                break;
        }
        return _class;
    }

    getButtonIconClassBasedOnState(state) {
        let _class = '';
        switch (state) {
            case 'active':
                _class = `svg-icon-floating-action-button-active`;
                break;
            case 'inactive':
                _class = ``;
                break;
        }
        return _class;
    }

    getButtonIconBackgroundClassBasedOnState(state) {
        let _class = 'bg-primary';
        switch (state) {
            case 'active':
                _class = `bg-light`;
                break;
            case 'inactive':
                _class = `bg-primary`;
                break;
        }
        return _class;
    }

    handleEnlargeText() {
        let body = document.documentElement.querySelector('body');
        // body.style.fontSize = '20px';
        switch (this.accessibilityEnlargeTextState) {
            case 'active':
                body.classList.remove('enlarge-text');
                this.accessibilityEnlargeTextState = 'inactive';
                this.storageModule.setItem('localStorage', 'enlarge-text', '0');
                break;
            case 'inactive':
                body.classList.add('enlarge-text');
                this.accessibilityEnlargeTextState = 'active';
                this.storageModule.setItem('localStorage', 'enlarge-text', '1');
                break;
            default:
                break;
        }

        this.requestUpdate();

    }

    handleTextToSpeech() {
        console.log('handleTextToSpeech', this.accessibilityTextToSpeechState);
        switch (this.accessibilityTextToSpeechState) {
            case 'active':
                this.accessibilityTextToSpeechState = 'inactive';
                // TODO: disable speaking in this case
                this.textToSpeechModule.handleDeactivation();
                window.speechSynthesis.cancel(); // cancel utterance
                this.storageModule.setItem('localStorage', 'text-to-speech', '0');
                break;
            case 'inactive':
                this.textToSpeechModule.handleActivation();
                this.textToSpeechModule.introduce();
                this.accessibilityTextToSpeechState = 'active';
                this.storageModule.setItem('localStorage', 'text-to-speech', '1');
                break;
            default:
                break;
        }
        this.requestUpdate();
    }

    handleHighContrastButtonClick() {
        this.storageModule.setItem('localStorage', 'nexus-theme-switched', 1);
        console.log('handleHighContrastButtonClick', this.accessibilityHighContrastState);
        switch (this.accessibilityHighContrastState) {
            case 'inactive':
                this.highContrastModule.handleActivation();
                this.themeId = 'high-contrast';
                this.accessibilityHighContrastState = 'active';
                this.accessibilityDarkThemeState = 'active';
                break;
            case 'active':
                this.highContrastModule.handleDeactivation();
                this.themeId = 'light';
                this.accessibilityHighContrastState = 'inactive';
                this.accessibilityDarkThemeState = 'inactive';
                break;

            default:
                break;
        }
        this.requestUpdate();
    }

    renderViewHeader(iconTitle, iconIdentifier, title) {
        let template = html`
        <div class="row bg-floating-action-button-darker rounded-0 rounded-top-3 py-3">
            <div class="col-auto">
                <div class="bg-light rounded-circle p-2">
                    <svg class="svg-icon svg-icon-hover svg-icon-size-30 static-color align-self-end my-auto">
                    <title>${iconTitle}</title>
                    <use href="#icon-${iconIdentifier}"></use>
                </svg>
                </div>
            </div>
            <div class="col align-self-center">
                <p class="mb-0">${title}</p>
            </div>
        </div>
        `;
        return template;
    }

    renderFloatingActionTriggerButton(identifier, state, title, iconIdentifier, iconTitle) {
        let template = html``;
        template = html`
        <div class="row">
            <div class="ms-auto col-auto pe-0">                  
                <button
                    id=${identifier}
                    title=${title}
                    type="button"
                    class="btn btn-floating-action-button rounded-5 fw-normal mb-3 ms-auto fab-trigger-button shadow-sm"
                    @mouseenter="${this.handleButtonMouseEnter}"
                    @mouseout="${this.handleButtonMouseOut}"
                    @click="${this.handleFloatingActionTriggerButtonMouseClick}"
                    >
                        <div class="row">
                            <div class="col text-align-start align-self-center pe-0 title-column d-none">
                                <small>
                                    ${title}
                                </small>
                            </div>
                            <div class=" col-auto py-1">
                                <svg class="${iconIdentifier} svg-icon svg-icon-hover svg-icon-size-30 align-self-end static-color my-auto">
                                    <title>${iconTitle}</title>
                                    <use href="#icon-${iconIdentifier}"></use>
                                </svg>
                            </div>
                        </div>
                </button>
            </div>
        </div>
            `;
        return template;
    }

    handleFloatingActionTriggerButtonMouseClick(element) {
        // let buttons = this.renderRoot.querySelectorAll('.fab-button');
        // console.log('what does this button do?', this.buttonsState, buttons);
        this.handleButtonsState();
        this.closeAllViews();
        this.requestUpdate();
    }

    setInitialState() {
        let buttons = this.renderRoot.querySelectorAll('.fab-button');
        this.buttonsState = 'closed';
        if (buttons) {
            buttons.forEach((button) => {
                button.classList.remove('d-flex');
                button.classList.add('d-none');
            });
        }
    }

    handleButtonsState() {
        let buttons = this.renderRoot.querySelectorAll('.fab-button');
        switch (this.buttonsState) {
            case 'closed':
                if (buttons) {
                    buttons.forEach((button) => {
                        button.classList.add('d-flex');
                        button.classList.remove('d-none');
                    });
                }
                this.buttonsState = 'open';
                break;

            case 'open':
                if (buttons) {
                    buttons.forEach((button) => {
                        button.classList.add('d-none');
                        button.classList.remove('d-flex');
                    });
                }
                this.buttonsState = 'closed';
                this.closeAllViews();
                break;

            default:
                break;
        }
    }

    hideAnyChatWidget() {
        if (window && window.fcWidget) {
            window.fcWidget.close();
        }
    }

    /**
     * Setup for handling what to do when clicking one of the items that show when 
     * triggering the FAB trigger button
     * 
     * @param {*} element 
     */
    handleButtonMouseClick(element) {

        if (element && element.target) {
            this.handleButtonsState();
            this.closeAllViews(); // close all, before opening one of the options
            let id = element.target.closest('button').getAttribute('id');
            if (id) {
                switch (id) {
                    case 'accessibility':
                        this.accessibilityViewState = 'open';
                        this.hideAnyChatWidget();
                        break;
                    case 'permissions':
                        this.permissionsViewState = 'open';
                        this.hideAnyChatWidget();

                        break;
                    case 'feedback':
                        this.feedbackViewState = 'open';
                        this.hideAnyChatWidget();
                        break;
                    case 'helpdesk':
                        this.helpdeskViewState = 'open';
                        break;

                    default:
                        break;
                }
            }

            this.requestUpdate();
        }
    }

    closeAllViews() {
        this.accessibilityViewState = 'closed';
        this.permissionsViewState = 'closed';
        this.feedbackViewState = 'closed';
        this.helpdeskViewState = 'closed';
    }

    handleButtonMouseOut(element) {
        if (element && element.target) {
            let column = element.target.closest('button, a').querySelector('.title-column');
            // console.log('handleButtonMouseOut', element, column);
            column.classList.add('d-none');
            column.classList.remove('d-flex');
        }
    }

    handleButtonMouseEnter(element) {
        if (element && element.target) {
            let column = element.target.closest('button, a').querySelector('.title-column');
            // console.log('handleButtonMouseEnter', element, column);
            column.classList.add('d-flex');
            column.classList.remove('d-none');
        }
    }
}

window.customElements.define('nexus-floating-action-button', FloatingActionButtonComponent);